export const allSteps = [
  {
    step: 35,
    description: "Invoice confirmed and locked for editing",
    rqd: "/",
  },
  {
    step: 40,
    description: "Fiscalized",
    rqd: "35",
  },
  {
    step: 43,
    description: "Original PDF modified (with fiscalization data)",
    rqd: "35, 40",
  },
  {
    step: 45,
    description: "Generate PDF, before sending to TAP",
    rqd: "35",
  },
  {
    step: 47,
    description: "PDF set as primary attachment to invoice",
    rqd: "35, 45",
  },
  {
    step: 50,
    description: "Generate UBL specific to country",
    rqd: "35",
  },
  {
    step: 55,
    description: "Generate Peppol UBL",
    rqd: "35",
  },
  {
    step: 70,
    description: "Send to tax authority (TAP)",
    rqd: "35, 50",
  },
  {
    step: 80,
    description: "Send to Peppol",
    rqd: "35, 50",
  },
  {
    step: 83,
    description: "Modify pdf document wih fiscalization and sending data",
    rqd: "35, (40), (50, 70), (55, 80)",
  },
  {
    step: 85,
    description: "Generate pdf document wih fiscalization and sending data",
    rqd: "35, (40), (50, 70), (55, 80)",
  },
  {
    step: 999,
    description: "All steps set as default for specific country",
    rqd: "/",
  },
];

export const allDocTypes = [
  {
    doc: "PDF",
    description: "Primary PDF document for invoice.",
  },
  {
    doc: "PDFO",
    description: "Original PDF document received by service.",
  },
  {
    doc: "XMLS",
    description:
      "Country specific XML of e-invoice. (e.g.: UBL 2.1 with country specific extension fields.)",
  },
  {
    doc: "XMLP",
    description: "Peppol XML for e-invoice.",
  },
];
